'use client';

import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';
import { Conditional, useDrawer } from '@cat-ecom/pcc-components';
import DealerOtherBranchesDrawer from '../dealer-other-branches/DealerOtherBranchesDrawer';
import { DealerOtherBranchResponse } from 'services/dealer-branches/types';

interface CheckOtherLocationsAvailabilityButtonProps {
  showAvailabilityBranchLink: boolean;
  dealerBranchInfo?: DealerOtherBranchResponse;
}
const CheckOtherLocationsAvailabilityButton = ({
  showAvailabilityBranchLink,
  dealerBranchInfo
}: CheckOtherLocationsAvailabilityButtonProps) => {
  const t = useTranslations();
  const dealerOtherBranchesDrawer = useDrawer({
    id: 'dealer-otherBranches-drawer',
    size: 'lg'
  });

  return (
    <Conditional
      test={showAvailabilityBranchLink && !!dealerBranchInfo?.locations}
    >
      <div className="d-inline-block">
        <CatButton
          variant="inline"
          className="p-0 d-print-none"
          onClick={dealerOtherBranchesDrawer.openDrawer}
        >
          <div className={'u-fs--12'}>
            {t('AVAILABLE_CHECK_IN_BRANCH_LOCATIONS')}
          </div>
        </CatButton>
      </div>
      <DealerOtherBranchesDrawer
        drawer={dealerOtherBranchesDrawer}
        dealerBranchInfo={dealerBranchInfo}
      />
    </Conditional>
  );
};

export default CheckOtherLocationsAvailabilityButton;
